import React, { useState } from 'react';
import styles from './InsightNotificationCard.module.scss';
import { INSIGHTS_COPY } from './insightsCopy';

const InsightNotificationCard = ({ item, onOpen, onAck, onOpenMember }) => {
  const [membersExpanded, setMembersExpanded] = useState(false);
  const hasMembers = item.members?.length > 0;

  const handleOpen = () => onOpen?.(item);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpen();
    }
  };

  const handleAck = (event) => {
    event?.stopPropagation?.();
    if (item.isUnread) onAck?.(item);
  };

  const toggleMembers = (event) => {
    event.stopPropagation();
    setMembersExpanded((expanded) => !expanded);
  };

  const handleMemberOpen = (event, member) => {
    event.stopPropagation();
    onOpenMember?.(item, member);
  };

  return (
    <div
      className={`${styles.card} ${item.isUnread ? styles.unread : ''}`}
      role="button"
      tabIndex={0}
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.header}>
        <div className={styles.content}>
          <span className={styles.title}>{item.title}</span>
          <span className={styles.summary}>{item.summary}</span>
          {hasMembers && (
            <button type="button" className={styles.toggleMembers} onClick={toggleMembers}>
              {membersExpanded ? INSIGHTS_COPY.hideMembers : INSIGHTS_COPY.showMembers}
            </button>
          )}
        </div>
        {item.isUnread && (
          <button
            type="button"
            className={styles.unreadDot}
            aria-label={INSIGHTS_COPY.markRead}
            title={INSIGHTS_COPY.markRead}
            onClick={handleAck}
          />
        )}
      </div>
      {hasMembers && membersExpanded && (
        <div className={styles.members}>
          {item.members.map((member) => {
            const memberHref = member.href || member.meta?.href;
            if (memberHref) {
              return (
                <button
                  key={`${member.memberKind}:${member.memberId}`}
                  type="button"
                  className={styles.memberLink}
                  onClick={(event) => handleMemberOpen(event, member)}
                >
                  {member.label}
                </button>
              );
            }
            return (
              <span key={`${member.memberKind}:${member.memberId}`} className={styles.memberLabel}>
                {member.label}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default InsightNotificationCard;
